export default __webpack_public_path__ + "static/media/recive.fe414510.svg";